import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import { HiArrowRight, HiPhone } from "react-icons/hi";

export default function Slider() {
  const slides = [
    // {
    //   img: "https://res.cloudinary.com/dcmevbyyo/image/upload/v1785764750/400057fa-639e-4920-b79c-a382883564d0_t4mr9p.png",
    //   alt: "Efficient Waterproofing Solutions",
    //   badge: "Commercial & Residential Solutions",
    // },
  ];

  return (
    <div className="w-full relative pt-24 sm:pt-28 md:pt-32 pb-10 sm:pb-14 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Main Showcase Container */}
        <div className="relative group w-full">
          {/* Swiper Container */}
          <Swiper
            centeredSlides={true}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
            }}
            loop={true}
            effect={"fade"}
            fadeEffect={{ crossFade: true }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            modules={[Autoplay, Pagination, EffectFade]}
            className="mySwiper w-full rounded-2xl md:rounded-3xl overflow-hidden bg-white shadow-xl border border-slate-200/60"
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index} className="w-full">
                <div className="relative w-full h-[260px] xs:h-[320px] sm:h-[420px] md:h-[500px] lg:h-[580px] overflow-hidden">
                  <img
                    src={slide.img}
                    className="w-full h-full object-fill select-none"
                    alt={slide.alt}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

      </div>
    </div>
  );
}


